import ACTIONS from '../actionTypes/contract';
import ContractService from '../../services/ContractService';
import ApiBuilder from '../../helpers/ApiBuilder';
import StorageService from '../../services/StorageService';
import { StorageConstants } from '../../constants';

export const getUserContracts = () => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.UPDATE_USER_CONTRACTS });
    return ContractService.getUserContracts().then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.UPDATE_USER_CONTRACTS_SUCCESS, payload: res.data });

        // select contract automatically if only one contract available
        if (res.data.length == 1) {
       //   dispatch(selectContract(res.data[0].id))
        }
      } else {
        dispatch({ type: ACTIONS.UPDATE_USER_CONTRACTS_FAILED });
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.UPDATE_USER_CONTRACTS_FAILED });
    });
  };
};

export const selectContract = (id) => {
  return (dispatch, getState) => {
    const { user: { GlobalIdentity = '' } } = getState();

    // Set header value
    ApiBuilder.setContractIdHeader(id)

    // Updating local storage values
    const previousContractId = StorageService.getItem(StorageConstants.SELECTED_CONTRACT_ID)
    StorageService.setItem(StorageConstants.PREVIOUS_CONTRACT_ID, previousContractId ?? null);
    StorageService.setItem(StorageConstants.SELECTED_CONTRACT_ID, id);

    // Dispatch action
    dispatch(getAgreementsForContract(id))
    dispatch({ type: ACTIONS.UPDATE_SELECTED_CONTRACT, payload: id, globalIdentity: GlobalIdentity })
  };
};

export const getAgreementsForContract = (contractId) => {
  return (dispatch, getState) => {
    const { user: { GlobalIdentity = '' } } = getState();
    dispatch({ type: ACTIONS.UPDATE_AGREEMENTS_LIST });
    return ContractService.getAgreementsForContract(contractId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.UPDATE_AGREEMENTS_LIST_SUCCESS, payload: { data: res.data, contractId, globalIdentity: GlobalIdentity } });
      } else {
        dispatch({ type: ACTIONS.UPDATE_AGREEMENTS_LIST_FAILED });
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.UPDATE_AGREEMENTS_LIST_FAILED });
    });
  };
};

export const resetContractStore = () => {
  return { type: ACTIONS.CLEAR_CONTRACT_INFO }
};

export const acceptAgreement = (agreementId, contractId) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.ACCEPT_AGREEMENT, payload: agreementId });
    return ContractService.acceptAgreement(agreementId, contractId).then((res) => {
      dispatch({ type: ACTIONS.ACCEPT_AGREEMENT_SUCCESS, payload: res.data });
      // removed since agreeing to one by one and in last dispatching this
      // dispatch(getAgreementsForContract(contractId))
    }).catch(() => {
      dispatch({ type: ACTIONS.ACCEPT_AGREEMENT_FAILED });
    });
  };
};

export const updateAgreementsSilently = (contractId) => {
  return (dispatch, getState) => {
    const { user: { GlobalIdentity = '' } } = getState();

    return ContractService.getAgreementsForContract(contractId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.UPDATE_AGREEMENTS_LIST_SUCCESS_SILENTLY, payload: { data: res.data, contractId, globalIdentity: GlobalIdentity } });
      }
    }).catch(() => { });
  };
}

export const updateContractListSilently = (contracts = [], selectedContract) => {
  return ({ type: ACTIONS.UPDATE_CONTRACT_LIST_SILENTLY, payload: { contracts, selectedContract } });
}

  export const updateContractInfoSilently = (selectedContract) => { 
  return async (dispatch) => {
    try {
      const contractRes = await ContractService.getUserContracts();
      if (contractRes && contractRes.data) {
        const currentContract = contractRes.data?.find(e => e.id == selectedContract?.id);
        if (currentContract) {
          currentContract.customer.managers = currentContract?.customer?.managers || [];
        }
        dispatch(updateContractListSilently(contractRes.data, currentContract))
      }
    }
    catch (e) { }
  }
}

export const createContract = (email, displayName, companyName) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.CREATE_CONTRACT});
    debugger
    return ContractService.createContract(email, displayName, companyName).then((res) => {
      dispatch({ type: ACTIONS.CREATE_CONTRACT_SUCCESS, payload: res.data });
      return true;
    }).catch(() => {
      dispatch({ type: ACTIONS.CREATE_CONTRACT_FAILED });
    });
  };
};